export default __webpack_public_path__ + "static/media/foto_02.b58f12d0.jpg";